/* tslint:disable */
import {
  Metadata,
  Apptype,
  App
} from '../index';

declare var Object: any;
export interface MetafieldInterface {
  fieldtype: string;
  name: string;
  status: string;
  label: string;
  description: string;
  displayformat?: string;
  sortorder: number;
  lastupdatedby?: string;
  createdby?: string;
  id?: any;
  metadataId?: any;
  apptypeId?: any;
  appId?: any;
  createdAt: Date;
  updatedAt: Date;
  metadata?: Metadata;
  apptype?: Apptype;
  app?: App;
}

export class Metafield implements MetafieldInterface {
  fieldtype: string;
  name: string;
  status: string;
  label: string;
  description: string;
  displayformat: string;
  sortorder: number;
  lastupdatedby: string;
  createdby: string;
  id: any;
  metadataId: any;
  apptypeId: any;
  appId: any;
  createdAt: Date;
  updatedAt: Date;
  metadata: Metadata;
  apptype: Apptype;
  app: App;
  constructor(data?: MetafieldInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Metafield`.
   */
  public static getModelName() {
    return "Metafield";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Metafield for dynamic purposes.
  **/
  public static factory(data: MetafieldInterface): Metafield{
    return new Metafield(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Metafield',
      plural: 'metafields',
      properties: {
        fieldtype: {
          name: 'fieldtype',
          type: 'string'
        },
        name: {
          name: 'name',
          type: 'string'
        },
        status: {
          name: 'status',
          type: 'string'
        },
        label: {
          name: 'label',
          type: 'string'
        },
        description: {
          name: 'description',
          type: 'string'
        },
        displayformat: {
          name: 'displayformat',
          type: 'string'
        },
        sortorder: {
          name: 'sortorder',
          type: 'number'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        metadataId: {
          name: 'metadataId',
          type: 'any'
        },
        apptypeId: {
          name: 'apptypeId',
          type: 'any'
        },
        appId: {
          name: 'appId',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        metadata: {
          name: 'metadata',
          type: 'Metadata',
          model: 'Metadata'
        },
        apptype: {
          name: 'apptype',
          type: 'Apptype',
          model: 'Apptype'
        },
        app: {
          name: 'app',
          type: 'App',
          model: 'App'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Metafield.ts